import { LOGGER, merge } from '@cicero/data/utils'
import { IPageFilter, IPageFilterOptionLookup, PAGE_FILTERS_TO_QUERY } from '../filters'
import { IQuery } from '../helpers'
import { PageSchema } from '../PageSchema'

export const mapFiltersToPageQuery = (
  filters: IPageFilter[],
  optionLookup: IPageFilterOptionLookup,
  search?: string
): { pageQuery: IQuery | null, attributeQuery: IQuery | null } => {
  const options = Object.values(optionLookup)
  const f = filters.reduce((acc, filter) => {
    const opt = optionLookup[filter[0]]

    if (opt) {
      const { type } = opt
      if (acc[type] === undefined) { acc[type] = [] }
      acc[type].push({ filter, opt })
    } else {
      LOGGER.warn('could not handle a filter, ignoring', { filter, optionLookup })
    }

    return acc
  }, { page: [], attribute: [] } as any)

  const attributeQuery = f.attribute?.length ? PAGE_FILTERS_TO_QUERY(f.attribute.map((a: any) => a.filter), options) : null
  let pageQuery = f.page?.length ? PAGE_FILTERS_TO_QUERY(f.page.map((a: any) => a.filter), options) : null
  if (search) { pageQuery = merge(PageSchema.QUERIES.search(search), pageQuery || {}) }

  return { pageQuery, attributeQuery }
}
